import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Skeleton } from 'primereact/skeleton';
import React from 'react';
/** Number of placeholder rows while list data is loading */
export const TABLE_SKELETON_ROW_COUNT = 10;
/** Skeleton rows use negative numeric ids (never returned by the API). */
export const isTableSkeletonRow = (row) => typeof row.id === 'number' && row.id < 0;
export const tableCellSkeleton = () => _jsx(Skeleton, { height: "1rem", className: "w-full max-w-full" });
export const tableActionButtonsSkeleton = ({ buttonCount = 3 } = {}) => (_jsx(_Fragment, { children: Array.from({ length: buttonCount }, (_, i) => (_jsx(Skeleton, { width: "1.75rem", height: "1.75rem", borderRadius: "4px", className: "inline-block p-mx-1" }, i))) }));
